import { Record, type RecordOf } from 'immutable';

import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

export const MILESTONE_REDUCER_KEY = 'milestonesStore';

export type MilestoneContent = {
  currentStatus?: string;
  description2?: string;
  [key: string]: unknown;
};

export type MilestoneProps = {
  achievementId?: string;
  clientId?: string | null;
  completedOn?: string;
  content?: MilestoneContent;
  createdAt?: string;
  currentAmount?: number;
  currentCount?: number;
  description?: string;
  id?: string | null;
  imageLink?: string | null;
  isDeleted?: boolean | null;
  knownMilestoneId?: string;
  knownMilestoneItemId?: string;
  limitType?: string;
  modifiedAt?: string;
  name?: string;
  occurenceType?: string;
  periodType?: string;
  state?: string;
  status?: string;
  targetAmount?: number;
  targetCount?: number;
  timesAchieved?: number;
  type?: string;
};

export type Milestone = RecordOf<MilestoneProps>;
export type MilestonesStore = QcsSyncResourceStore<MilestoneProps>;

export type MilestoneNotificationPayload = {
  milestoneData: Milestone[];
};

export type UpNextMilestone = {
  milestone: Milestone;
};

export type UpNextMilestonesResult = {
  count: number;
  milestoneArr: UpNextMilestone[];
  recentlyEarned: Milestone[];
  total: number;
};

export type AchievementCompletionStatus = {
  isCompleted: boolean;
  justStarted: boolean;
};

export const mkMilestoneDefaults = Record<MilestoneProps>({
  achievementId: undefined,
  clientId: undefined,
  completedOn: undefined,
  content: undefined,
  createdAt: undefined,
  currentAmount: undefined,
  currentCount: undefined,
  description: undefined,
  id: undefined,
  imageLink: undefined,
  isDeleted: undefined,
  knownMilestoneId: undefined,
  knownMilestoneItemId: undefined,
  limitType: undefined,
  modifiedAt: undefined,
  name: undefined,
  occurenceType: undefined,
  periodType: undefined,
  state: undefined,
  status: undefined,
  targetAmount: undefined,
  targetCount: undefined,
  timesAchieved: undefined,
  type: undefined,
});

export const mkMilestone = (jsObj: Partial<MilestoneProps> = {}): Milestone =>
  mkMilestoneDefaults({
    ...jsObj,
  });
